<template>
  <span>
    &nbsp
  </span>
</template>

<script>

export default {
  name: 'ks-space',
  props:  {

  },
  methods: {

  }
}
</script>
